import { Controller } from "@hotwired/stimulus";
import { getJSON } from "../api.js";

// Badge salda portfela w nav (brutto łącznie; tooltip ze splitem wpłacone/bonus).
// Błąd API → badge zostaje ukryty (nawigacja nie może się wywalić).
export default class extends Controller {
  static values = {
    url: String, // /api/wallet/balance/
  };

  async connect() {
    let data;
    try {
      data = await getJSON(this.urlValue);
    } catch {
      this.element.hidden = true;
      return;
    }
    this.element.textContent = `${data.total_available_gross_pln} zł`;
    this.element.title = `Wpłacone: ${data.deposited_pln} zł · Bonus: ${data.bonus_pln} zł`;
    this.element.hidden = false;
  }
}
